<template>
    <div>
        <Pane title="重新提交设计确认" :showRemarks="false">
            <template>重新发起设计确认流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="项目名称">
                                    <a-input v-model="form.projectName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编号">
                                    <a-input v-model="form.designNo" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计阶段">
                                    <a-select v-model="form.phaseCode" disabled placeholder="">
                                        <a-select-option v-for="item in designPhaseList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="管理级别">
                                    <a-radio-group v-model="form.manageLevel" disabled>
                                        <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="确认时间">
                                    <a-date-picker
                                        v-model="form.affirmDate"
                                        style="width: 100%"
                                        placeholder="请选择确认时间"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="参与人员">
                                    <a-input v-model="form.participantNames" placeholder="请输入参与人员" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title" style="margin-top: 0">详细信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="24">
                                <a-form-item label="确认意见记录" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.affirmOpinion" :rows="3" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入确认意见" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="采取措施" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.measures" placeholder="请输入措施" :rows="3" style="max-width: 100%!important;width: 100%!important;" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title" style="margin-top: 0">其他信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col  :span="24">
                                <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.remark" placeholder="请输入措施" :rows="3" style="max-width: 100%!important;width: 100%!important;" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="附件">
                                    <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                                </a-form-item>
                            </a-col>

                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { fetchDesignAffirmDetail, resubmitDesignAffirm } from '@/api/project-execute/affirm'
import moment from 'moment'
import Attachment from "@/components/attachment";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'

export default {
    name: "DesignAffirmReapply",
    components: { Attachment },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            phaseId: "",
            taskId: "",
            instanceId: "",
            form: {
                projectName: "",
                designNo: "",
                phaseCode: "",
                manageLevel: "",
                affirmDate: null,
                participantNames: "",
                participantIds: "",
                measures: "",
                affirmOpinion: "",
                remark: "",
            },
            fileList: [],
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        majorList() {
            return (this.findDataDict && this.findDataDict("cosys.major")) || [];
        },
        designPhaseList() { return this.findDataDict('cosys.designPhase') || [] },
        manageLevelList() { return this.findDataDict('cosys.manageLevel') || [] },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }

        this.fetchDetail();
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail() {
            if (!this.id) {
                this.loading = false;
                return;
            }
            this.loading = true;
            fetchDesignAffirmDetail(this.id)
                .then(data => {
                    if (!data) return;
                    this.phaseId = data.phaseId || "";
                    this.form = {
                        projectName: data.projectName || "",
                        designNo: data.designNo || "",
                        phaseCode: data.phaseCode || "",
                        manageLevel: data.manageLevel || "",
                        affirmDate: data.affirmDate ? moment(data.affirmDate) : null,
                        participantNames: data.participantNames || "",
                        participantIds: data.participantIds || "",
                        measures: data.measures || "",
                        affirmOpinion: data.affirmOpinion || "",
                        remark: data.remark || "",
                    };
                    this.fileList = parseAttachment(data.attachment, data.attachmentPaths)
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submitReview() {
            this.submitting = true;
            const data = {
                id: this.id,
                phaseId: this.phaseId,
                projectName: this.form.projectName,
                designNo: this.form.designNo,
                phaseCode: this.form.phaseCode,
                manageLevel: this.form.manageLevel,
                affirmDate: this.form.affirmDate ? this.form.affirmDate.format('YYYY-MM-DD HH:mm:ss') : undefined,
                participantIds: this.form.participantIds,
                participantNames: this.form.participantNames,
                measures: this.form.measures,
                affirmOpinion: this.form.affirmOpinion,
                remark: this.form.remark,
                ...buildAttachmentData(this.fileList),
            };
            resubmitDesignAffirm(data)
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    // this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
